import { TOGGLE_PARKING_LOADER } from "./displayParkingLoaderReducer"

export const toggleParkingLoader = (value) => ({
    type: TOGGLE_PARKING_LOADER,
    payload: value
})